<template>
 <div>
  <form autocomplete="off">
    <div class="md-autocomplete-loading" v-show="isPromisePending">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <!-- Save button -->
    <CrudToolbar 
      :save="saveTaskSteps" 
      :form="form" 
      :$v="$v" 
      :formConfig="formConfig" 
      :btnActive="true" 
      :cancel="cancel"
      :isSaveInProgress="isSaveInProgress"
    ></CrudToolbar>

    <div class="md-layout">
      <grid-layout
        :layout.sync="formLayout"
        :col-num="12"
        :is-draggable="false"
        :is-resizable="false"
        :auto-size="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :responsive="false"
        :margin="[10, 10]"
        :use-css-transforms="true"
      >
        <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                  :x="slot.layout.x"
                  :y="slot.layout.y"
                  :w="slot.layout.w"
                  :h="slot.layout.h"
                  :i="slot.layout.i"
                  :key="'griditem_'+ slotName + slot.layout.i"
        >
        <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content">
          <h3>{{slot.label}}</h3>Create a base record to enable this section.
        </div>
        <div v-else :key="slotName" class="vue-grid-item-content vue-grid-item-content-scroll">
          <div v-if="$v && $v.form && showRequirements" class="requirementsNotice">
            <h4>The following fields require attention:</h4>
            <template v-for="(slot, slotName, index) in formConfig.slots">
              <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
                <template v-if="$v.form[name] && $v.form[name].$invalid">
                <p :key="`${name}-${index}`" :data-target="name" @click="scrollToField(name)" class="required-field-label">
                  <span class="fa-stack fa-sm" v-if="field.label === 'isAllowSave' ? '' : field.label">
                    <i class="far fa-circle fa-stack-2x text-danger"></i>
                    <i class="fas fa-times fa-stack-1x text-danger"></i>
                    <!-- <i class="far fa-circle fa-stack-2x text-success"></i>
                    <i class="fas fa-check fa-stack-1x text-success"></i> -->
                  </span>
                  {{field.label === "isAllowSave" ? "" : field.label}}
                </p>
                </template>
              </template>
            </template>
          </div>
          <h3>{{slot.label}}</h3>

          <md-field v-if="(formConfig.pageMode == 'new') && (taskTempList.length > 0)" class="_uiKitInput" style="margin-right: 30px;">
            <label >Template</label>
            <md-select v-model="taskTemp" name="taskTemp" id="taskTemp" :pageMode="formConfig.pageMode" @md-selected="taskSelected(taskTemp)">
                <md-option v-for="titem in taskTempList" :value="titem.id" :key="titem.id"> {{ titem.subject }} </md-option>
            </md-select>
          </md-field>

          <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
            
            <CrudCheckbox
              v-if="field.type == 'checkbox'" :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>
            
            <CrudSwitch
              v-else-if="field.type == 'switch'" :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>

            <CrudDatepicker
              v-else-if="field.type == 'datepicker'" :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

            <CrudSelect
              v-else-if="field.type == 'select'" :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

            <CrudAutocomplete
              v-else-if="field.type == 'autocomplete'" :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

            <CrudJson
              v-else-if="field.type == 'json'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

            <CrudId
              v-else-if="field.type == 'id'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

            <CrudText
              v-else :key="name" class="field"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

          </template>
        </div>
        <gridItemHook />

       </grid-item>
      </grid-layout>
    </div>
  </form>
  <!-- List of steps on view page -->
  <div>
    <template>
      <div v-if="(formConfig.pageMode == 'view' || formConfig.pageMode == 'assignee') && recordData">
        <br>
          <div class="row">
            <h5 class="title" >
              <md-icon>view_list</md-icon> Task Steps
            </h5>
            <div class="col-8" v-if="(lines[0].title !== null)">
              <table border="1" id="taskTable" class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th style="width:20%" scope="col">Title</th>
                    <th scope="col">Description</th>
                    <th style="width:20%" scope="col">Status</th>
                  </tr>
                </thead>
                  <tr v-for="item in lines" :key="item.order">
                    <td>{{ item.title }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.status }}</td>
                  </tr>
              </table>
            </div>
            <div v-if="(lines[0].title === null)"> Steps Not Defined </div>
          </div>
      </div>
    </template>
    <!-- Add steps form on edit and new page -->
    <template>
      <div class="md-layout-item md-size-100" v-if="(formConfig.pageMode == 'edit') || (formConfig.pageMode == 'new')">
        <h5 class="title" >
          <md-icon>view_list</md-icon> Task Steps
        </h5>
        
        <draggable tag="div" :list="lines" class="list-group" handle=".handle" v-bind="dragOptions" >
          <div v-for="(line, index) in lines" v-bind:key="index" class="row" style="margin-bottom: 5px;">
            <div class="md-layout step-layout" >
              <div class="md-layout-item md-size-5">
                <i class="fa fa-align-justify handle"></i>
              </div>
              <div class="md-layout-item md-size-20 field-layout align-input">
                <md-field class="_uiKitInput _uiKitDraggableInput">
                    <label>Title</label>
                    <md-input v-model="line.title" type="text" ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25 field-layout">
                  <md-field class="_uiKitInput _uiKitDraggableInput">
                        <label>Description</label>
                        <md-textarea class="text-area" v-model="line.description"></md-textarea>
                  </md-field>
              </div>
              <div class="md-layout-item md-size-20 field-layout align-input">
                <md-field class="_uiKitInput _uiKitDraggableInput">
                      <label >Status</label>
                      <md-select v-model="line.status" name="status" id="status" :form="form" :pageMode="formConfig.pageMode">
                          <md-option value="Open" selected>Open</md-option>
                          <md-option value="In Progress">In Progress</md-option>
                          <md-option value="Complete">Complete</md-option>
                      </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-5">
                <md-button class="md-primary md-just-icon" v-if="index + 1 === lines.length" @click="addLine"><md-icon >add_circle</md-icon></md-button>
              </div>
              <div class="md-layout-item md-size-5">
                <md-button class="md-primary md-just-icon" @click="removeLine(index,line)"><md-icon >clear</md-icon></md-button>
              </div>
            </div>
          </div>
        </draggable>  
      </div>
    </template>
  </div>

 </div>
</template>

<script>
  import _ from "lodash";
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as mutations from '@/graphql/mutations';
  import * as queries_custom from '@/graphql/queries_custom';
  import { required, numeric, minLength } from "vuelidate/lib/validators";
 
  import draggable from "vuedraggable";
  import Swal from "sweetalert2";
  import { filter } from 'minimatch';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      this.$parent.$parent.$parent.gridItems.push(this.$parent);
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "config-form",
    mixins: [RecordForm],
    props: {
      addTaskToTaskList: {
        type: Boolean,
        required: false
      },
      caseMode: {
        type: String,
        required: false
      }
    },
    components: {
        draggable,
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        gridItemHook
    },
    data () {
      return {
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        lines: [],
        taskTempList: [],
        taskTemp:"",
        blockRemoval: true,
        dragging: false,
        stepCount: 0,
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      recordData () {
        if(this.recordData.steps.items.length > 0) {
          this.lines = _.orderBy(this.recordData.steps.items, 'order');
        } 
      }
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      },
      showRequirements() {
        let result = false;
         if (this.formConfig && this.formConfig.pageMode === 'new' && this.$v.form.$invalid && !this.$route.params.id) {
          result = true;
        }
        if(this.formConfig.pageMode === 'edit'){
          if(this.recordData && this.recordData.id && this.$v.form.$invalid){
            result = true;
          }
        }
        return result;
      },
    },
    methods: {
      taskSelected (templateId) {
        if ((templateId != 'open')) {
          if(this.checkFieldsChanges()){
            Swal.fire({
              title: 'Do you want to apply the template?',
              text: "You have made changes that will be overwritten.",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then((result) => {
              if (result.value) {
                this.addTemplateValues(templateId);
              }else{
                this.taskTemp = 'open';
              }
            })
          } else {
            this.addTemplateValues(templateId);
          }
        }         
      },
      scrollToField(target){
        const selector = `.vue-grid-item-content-scroll [name="${target}"]`;
        const eleTarget = document.querySelector(selector);
        if (eleTarget) {
          const eleParent = eleTarget.closest('.field')
          if(eleParent) {
            eleParent.scrollIntoView({
              behavior:"smooth"
            });
          } else {
            eleTarget.scrollIntoView({
              behavior:"smooth"
            });
          }
        }
      },
      addTemplateValues (templateId) {
        this.$loopo(this.taskTempList, (value, key) => {
          if (value.id == templateId) {
            this.$v.form.type.$model = value.type;
            this.$v.form.subject.$model = value.subject;
            this.$v.form.priority.$model = value.priority;
            this.$v.form.status.$model = value.status;
            this.$v.form.isCompleteInOrder.$model = value.isCompleteInOrder;
            /**
             * ATLAS-530: Assignee assigned to Template is not getting 
             * populated when applied to Task
            */ 
            if (value.user && value.user !== null) {
              (($this) => {
                $this.searchTerm = value.user.given_name + ' ' + value.user.family_name;
                this.form.taskUserId = value.user.id;
              })(this.formConfig.fields.taskUserId);
            } else {
              //if selected template has no user then set assignee field to blank
              (($this) => {
                $this.searchTerm = '';
                this.form.taskUserId = '';
              })(this.formConfig.fields.taskUserId);
            }            
            
            if (value.steps.items.length) {
              this.lines = _.orderBy(value.steps.items, 'order');
            } else {
              this.lines = [];
              this.addLine();
            } 
          }
        });
      },
      checkFieldsChanges () {
        if (this.$v.form.subject.$anyDirty || this.$v.form.priority.$anyDirty || this.$v.form.type.$anyDirty ) {
          return true;
        } else {
          return false;
        }
      },
      async saveTaskSteps(){
        this.isPromisePending = true;
        this.isSaveInProgress = true; //disable Save button
        this.$v.$touch();

        if(this.$v.$invalid) {
          this.$c.log('save(): unable to save, $v.invalid');
          return;
        }
        let data = {};
        const form = this.form;
        const fields = this.formConfig.fields;

        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (typeof form[name] !== 'undefined' && form[name] !== null) {
              if (field.type === 'datepicker') {
                try{
                  data[name] = form[name].toUTCString();
                }catch (e) {
                  data[name] = form[name].toString();
                  console.log('datepicker try catch ',form[name])
                }
              } else {
                data[name] = form[name];
              }
            }
          } else {
            if (field.type === 'json') {
              data[name] = JSON.stringify(form[name].fields);
            }
          }
        });
        // We should not send any empty strings on create
        if (this.formConfig.pageMode == 'new') {
            this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                delete data[name];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  delete data[name];
                }
              }
            }
          });
        }
        if (this.formConfig.pageMode == 'edit') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                data[name] = null;
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  data[name] = null;
                }
              }
            }
          });
        }

        if (this.formConfig.isTemplateActive) {
          data.isTemplate = true;
        }

        /**
         * ATLAS-828 - ATLAS-810 Impact: Dashboard Logic is working on 
         * CLOSED status to find Tasks Done Today
         */
        if (data.status === 'Completed') {
          data.dateCompleted = new Date().toISOString();
        }

        /**
         * ATLAS-530 Make current user the default assignee when creating
         * a New Task from Manual Case creation -> Add Task popup -> New tab
         */
        if(!data.taskUserId) {
          data.taskUserId = this.$Session.userId;
        }
        this.$c.log('data has been prepared form=',data);

        //for casetask
        if(this.groupIndex && this.orderIndex) {
          //when task is created from case, $route.params.id is set as taskCaseId
          if(!this.taskCrud) {
            data.taskCaseId = this.$route.params.id;
          }
          data.group = this.groupIndex;
          data.order = this.orderIndex;
          this.$emit('dialogChange', false);
        }

        //create a unique task template entry 
        //if saveAsTemplate is checked true
        let saveAsTemplate = false;
        if(data.isTemplate === true) {
          saveAsTemplate = true;
        }
        
        if (!this.isCompleteInOrder) {
          data.isAvailable = true;
        }

        //ATLAS-1803: Add to task list when pageMode is New, don't save without caseId
        if (this.addTaskToTaskList && typeof this.$route.params.id === "undefined") {
          data.isTemplate = true;

          //add steps
          let stepItems = [];
          let steps = {};
          this.lines.forEach(el => {
            stepItems.push(el);
          });
          steps['items'] = stepItems;
          data.steps = steps;
          this.$emit('taskCreated', data);
          return;
        }

        data.isTemplate = false;
        if(this.formConfig.isTemplateActive === false) {
          await this.createTask(data);
        }
        if (saveAsTemplate) {
          data.isTemplate = true;
          delete data.taskCaseId;
          delete data.group;
          delete data.order;
          await this.createTask(data);
        }
      },
      async createTask(data){
        let query = this.getMutation(this.formConfig.pageMode === 'edit'? this.formConfig.actions.update : this.formConfig.actions.save);
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }

        const result = await API.graphql(graphqlOperation(query, {input: data}))
          .then(result => {

            let responseKey = (this.formConfig.pageMode === 'new'? 'create' : 'update') + this.formConfig.objectName;
            let responseId = result.data[responseKey].id
            this.$c.log("success! responseKey = " + responseKey);
            this.$c.log("success! responseId = " + responseId);
            // this.$emit('taskCreated', result.data[responseKey]);
            
            let promiseArr = [];
            
            /**
             * @see https://zeamster.atlassian.net/browse/ATLAS-646
             * @see CustomCaseConfigForm.vue
             */
            let isFirstTaskStepMadeAvailable = false;
            let promiseTaskData = result.data[responseKey];

            this.$loopo(this.lines, (value, key) => {
              let setOrderVal = parseInt(key) + 1;
            
              // mark the first step that is not complete as available
              // check ATLAS-646 comment above
              if (promiseTaskData && promiseTaskData.isCompleteInOrder) {
                if (isFirstTaskStepMadeAvailable) {
                  value.isAvailable = false;
                } else {
                  let status = '';
                  if (value && value.status) {
                    status = value.status.toLowerCase();
                  }
                  if ('complete' != status) {
                    value.isAvailable = true;
                    isFirstTaskStepMadeAvailable = true;
                  } else {
                    value.isAvailable = false;
                  }
                }
              } else {
                value.isAvailable = true;
              }
              
              if (value.id && this.formConfig.pageMode === 'edit') {
                promiseArr.push(this.updateSteps(value, responseId, setOrderVal));
              } else {
                promiseArr.push(this.createSteps(value, responseId, setOrderVal));
              } 
            }); 
            
            Promise.allSettled(promiseArr).then(async (resultPromise) => {
              
              let getTaskOperation = graphqlOperation(queries_custom['editTask'], { id: responseId });
              await API.graphql(getTaskOperation)
                .then(response => {
                  //ATLAS-1845: <Cases><Add Task Popup> Task Template steps are not getting copied on newly created task
                  if (this.caseMode && this.caseMode === 'view') {
                    response.data.getTask['isTaskStepsUpdate'] = true;
                  }
                  this.$emit('taskCreated', response.data.getTask);
                });
              
              this.isPromisePending = false;
              if(this.taskCrud) {
                this.$router.push(this.formConfig.listPath + '/' + responseId);       
                this.loadData(result.data[responseKey]);
                this.formConfig.pageMode = 'view';
              }
            })
          })
          .catch(error => {
            this.$c.log(error);
          });
      },
      createSteps (stepsData, taskId, orderVal) {
        //ATLAS-815 Default Task Step status - Open
        let inputstepsData = {
          title: stepsData.title,
          description: stepsData.description,
          taskStepTaskId: taskId,
          status: (stepsData.status === null ? "Open" : stepsData.status),
          isAvailable: stepsData.isAvailable,
          order: orderVal
        };
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          inputstepsData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
        
        let gqlRequest = graphqlOperation(mutations['createTaskStep'], {input: inputstepsData});
        this.$c.log('gqlRequest create steps', gqlRequest);
        return API.graphql(gqlRequest)
      },
      updateSteps (stepsData, taskId, orderVal) {
        let inputstepsData = {
          id: stepsData.id,
          title: stepsData.title,
          description: stepsData.description,
          taskStepTaskId: taskId,
          status: stepsData.status,
          isAvailable: stepsData.isAvailable,
          order: orderVal
        };
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          inputstepsData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
        
        let gqlRequest = graphqlOperation(mutations['updateTaskStep'], {input: inputstepsData});
        this.$c.log('gqlRequest update step', gqlRequest);
        return API.graphql(gqlRequest)
      },
      async deleteSteps (stepsData) {
          let inputstepsData = {
            id: stepsData.id
          };
          let gqlRequest = graphqlOperation(mutations['deleteTaskStep'], {input: inputstepsData});
          this.$c.log('gqlRequest delete step', gqlRequest);

        const result = await API.graphql(gqlRequest)
        .then(result => {
          this.$c.log(result);
        })
        .catch(error => {
          this.$c.log(error);
        });
      },
      removeLine (lineId, stepItem) {
        if (this.blockRemoval) {
          this.lines.splice(lineId, 1);
          this.lines.push({
            title: null,
            description: null,
            status: null
          });  
        }
        else this.lines.splice(lineId, 1);
      },
      addLine () {
        let checkEmptyLines = this.lines.filter(line => line.number === null)
        if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          title: null,
          description: null,
          status: 'Open'
        })  
      },
      async getTasksList () {
        let params = {}, operation, response = [];
        params.filter = {esQuery: JSON.stringify({"match": {"isTemplate": true }})};
        params.limit = 999;
        operation = graphqlOperation(queries_custom['searchTasksSteps'], params);
        console.log('query-------------------------------------------', operation);
        const result = await API.graphql(operation);
        let taskTempates = result.data.searchTasks.items;

        //sort template name alphabetically
        const sortedItems = _.sortBy(taskTempates,[function(o) { return o.subject.toLowerCase(); }]);

        if (sortedItems.length) {
          sortedItems.filter(_item => {
            if (_item.hasWorkflow) {
              console.log('skip this task template as it is of workflow...')
            } else {
              this.taskTempList.push(_item)
            }
          });         
        }       
      }
    },
    mounted () { 
      this.addLine();
      this.getTasksList();
    }
  };
</script>

<style lang="scss" scoped>
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {
    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

 .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }

   #taskTable{
    border-collapse: collapse;
    border: 1px solid #d6d2d2;
    width: auto;
    text-align: center;
  }
  #taskTable td{
    border-left: 0px none;
    padding:5px;
    
  }
  .step-layout{
    border: 0.5px solid #ccc; 
    background-color: #f4fcfc;
    padding: 10px 0;
  }
  .handle {
    float: left;
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .field-layout .md-field{
    padding-bottom: 8px;
    margin: 5px 0 0;
  }
  .md-button.md-primary, .md-button.md-primary:hover, .md-button.md-primary:focus, .md-button.md-primary:active, .md-button.md-primary.active, .md-button.md-primary:active:focus, .md-button.md-primary:active:hover, .md-button.md-primary.active:focus, .md-button.md-primary.active:hover, .open > .md-button.md-primary.dropdown-toggle, .open > .md-button.md-primary.dropdown-toggle:focus, .open > .md-button.md-primary.dropdown-toggle:hover {
    background-color: #b3aead !important;
    width: 10px;
    height: 27px;
  }
  .md-layout-item .md-size-5{
    padding-top: 26px;
    padding-bottom: 26px;
  }
  .md-has-textarea .text-area{
    padding-left:0px !important;
    padding-right:30px !important;
  }
  h5.title {
    margin-bottom: 10px !important;
  }
  .align-input { 
    padding-top:9px; 
  }

  .requirementsNotice {
    background-color: lightyellow;
    border: 1px solid black;
    border-radius: 5px;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;

    h4 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: bold;
    }
    p {
      margin-bottom: 0;
      margin-top: 5px;
    }
    .fa-stack.fa-sm {
      font-size: 10px;
    }
    .required-field-label {
      color: #2196f3;
      cursor: pointer;
    }
  }
  
</style>